module.exports = __webpack_public_path__ + "static/img/4yiliao.7d8ee0d2.png";